import { getOverviewPath } from 'Sections/overview/routes';
import { getSuccessPurchaseUrl } from './routes';

export const DEFAULT_ORIGIN = '/overview';
export const NEW_LISTING_ORIGIN = '/es/list/new';
export const DEFAULT_PURCHASE_SUCCESS_URL = getSuccessPurchaseUrl();
export const DEFAULT_PURCHASE_CANCEL_URL = getOverviewPath();
